import { getErrorMessage } from "@/core/services";
import { useAsyncQuery } from "@/ds";
import { listFinanceiroTiposObra } from "@/modules/financeiro-obras";
import type { FinanceiroTipoObraOpcao } from "@/modules/financeiro-obras";

const SEM_TIPOS: FinanceiroTipoObraOpcao[] = [];

export const TIPOS_OBRA_FORBIDDEN_MESSAGE =
  "Você não tem permissão para consultar os Tipos de Obra.";
export const TIPOS_OBRA_ERROR_MESSAGE = "Não foi possível carregar os Tipos de Obra.";

export function useTiposObraOpcoes() {
  const consulta = useAsyncQuery<FinanceiroTipoObraOpcao[]>({
    fetcher: (signal) => listFinanceiroTiposObra({ signal }),
    queryKey: "distribuicoes:tipos-obra",
    initialData: SEM_TIPOS,
    forbiddenMessage: TIPOS_OBRA_FORBIDDEN_MESSAGE,
    errorMessage: TIPOS_OBRA_ERROR_MESSAGE,
    resolveErrorMessage: getErrorMessage,
  });

  return {
    tipos: consulta.data,
    carregando: consulta.status === "loading",
    erro:
      consulta.status === "error" || consulta.status === "forbidden" ? consulta.errorMessage : null,
    recarregar: consulta.reload,
  };
}
